import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      // Wait for Firebase Auth to initialize
      await authService.waitForInitialization();
      setIsInitialized(true);
      
      // Now check authentication state
      const isAuth = authService.isAuthenticated();
      setIsAuthenticated(isAuth);
    };

    initializeAuth();
  }, []);

  // Show loading while Firebase Auth initializes
  if (!isInitialized) {
    return (
      <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, var(--obsidian-black) 0%, #1a1d23 100%)' }} />
    );
  }

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, var(--obsidian-black) 0%, #1a1d23 100%)' }} />
    );
  }

  if (!isAuthenticated) {
    // Redirect to homepage with modal open and error message
    return <Navigate to="/?loginRequired=true" replace />;
  }

  return <>{children}</>;
}; 